<div class="question-bar">
  <div class="question-bar__select">
    <div class="question-bar__select-label">{{questionService?.getSection('header','header_logo')?.description}}</div>
    <!-- <strong class="question-bar__select-location">{{questionService?.getSection('header','header_logo')?.description}}</strong> -->
  </div>
</div>
<main class="page-main">


  <div class="container layout layout--questions">

    <!--
    remove 'in' class' and attach 'out' class after question complete (on 'next' click)
    attach 'in' class after loading new question to trigger animation if it's being ajax'ed in
    -->
    <div class="layout__main in">


      <div class="question-stepper">
        <div class="question-stepper__img question-stepper__img--avatar">
          <img src="/assets/1/avatar/happy.png" class="icon">
        </div>
        <div class="question-stepper__content">

          <h3 class="font-normal">{{questionService?.getSection('header','header_logo')?.description}}</h3>

          <div class="question-panel question-panel--lg">

            @for (question of questions; track question; let last = $last) {
              @if (!question?.parent_control) {
                <app-question-controller
                  [question]="question"
                  [showLabel]="true"
                  [controlCssClass]="(!last ? ' mb-30' : '')"
                  [readOnly]="readonly"
                  [isEditModal]="true"
                  [showParent]="true"
                  [showTotal]="false"
                  [childItemQuestions]="getItemChildrenQuestions(question)"
                  (questionAnswer)="questionResponse($event)">
                </app-question-controller>
              }
            }


            <aside class="question-fyi">
              <div class="question-fyi__icon">
                <img src="/assets/1/icn/message-avatar.svg" class="icon">
              </div>
              <div class="question-fyi__content">
                <h6>Important to know</h6>
                <p>We need you to tell us how much time each day (%) is spent
                  on office work/manufacturing, storage work, retailing,
                hospitality, residential use etcetera, as applicable.</p>
              </div>
            </aside>

          </div>
        </div>
      </div>




    </div>

  </div>
  <!-- /layout -->


</main>
<app-disclaimer></app-disclaimer>
<footer class="question-tray">
  <div class="container">
    <div class="question-tray__controls">
      <a href="javascript:;"  (click)="removeLocation()" class="question-tray__back">
        <svg class="icon">
          <use xlink:href="#arrow-left"></use>
        </svg>
      </a>
      <div class="question-tray__btns">
        <a href="javascript:;"  (click)="removeLocation()" class="button button--lg button--secondary">Cancel</a>
        @if (isEditMode) {
          <a href="javascript:;" (click)="addLocation()" class="button button--lg button--primary">Update location</a>
        }
        @if (!isEditMode) {
          <a href="javascript:;" (click)="addLocation()" class="button button--lg button--primary">Add location</a>
        }
      </div>
    </div>
  </div>
</footer>
<div class="modal fade modal--fullscreen" id="mobile-cart" tabindex="-1" role="dialog" aria-labelledby="mobile-quote-menu" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-cart">

      <div class="modal-cart__heading">
        <div class="container">
          <h6>Quote</h6>
          <a href="#" class="modal-cart__save">Save</a>
          <a href="#" class="modal-cart__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </a>
        </div>
      </div>
      <!-- /.modal-cart__heading-->


      <div class="modal-cart__content">

        <div class="container">

          <!-- duplication of desktop quote progress, less the subtotal row -->
          <div class="quote-progress">
            <div class="quote-progress__content">

              <div class="progress-tree">

                <div class="progress-tree__item is-complete">
                  <div class="progress-tree__branch">
                    <span><span></span></span>
                  </div>
                  <div class="progress-tree__content">
                    <div class="progress-tree__title">
                      <p>Personal Details</p>
                    </div>
                    <div class="progress-tree__detail">
                      <div class="progress-tree__detail-name" title="Bongani Lungani">Bongani
                      Lungani</div>
                      <div class="progress-tree__detail-actions">
                        <a href="#" class="action-remove text-link">Edit</a>
                      </div>

                      <div class="progress-tree__detail-track">
                        <div class="progress-tree__detail-trackfill" style="width:100%">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="progress-tree__item is-active">
                  <div class="progress-tree__branch">
                    <span><span></span></span>
                  </div>
                  <div class="progress-tree__content">
                    <div class="progress-tree__title">
                      <p>Vehicles</p>
                    </div>

                    <div class="progress-tree__detail">
                      <div class="progress-tree__detail-name" title="CAA 156893">CAA 156893
                      </div>
                      <div class="progress-tree__detail-discounts">
                        <svg class="icon">
                          <use xlink:href="#discount-summary-mini"></use>
                        </svg>
                      </div>
                      <div class="progress-tree__detail-cost">
                        <p><strong>R 99 999</strong> /mo</p>
                      </div>

                      <div class="progress-tree__detail-description">2016 Suzuki Jimny</div>

                      <div class="progress-tree__detail-actions">
                        <a href="#" class="action-remove text-link">Edit</a>
                        <span>|</span>
                        <a href="#" class="action-remove text-link">Remove</a>
                      </div>

                      <div class="progress-tree__detail-track">
                        <div class="progress-tree__detail-trackfill" style="width:80%">
                        </div>
                      </div>
                    </div>

                    <div class="progress-tree__detail is-active">
                      <div class="progress-tree__detail-name" title="CAA 156893">CAA 156893
                      </div>
                      <div class="progress-tree__detail-discounts">
                        <svg class="icon">
                          <use xlink:href="#discount-summary-mini"></use>
                        </svg>
                      </div>
                      <div class="progress-tree__detail-cost">
                        <p><strong>R 99 999</strong> /mo</p>
                      </div>

                      <div class="progress-tree__detail-description">2016 Suzuki Jimny</div>

                      <div class="progress-tree__detail-actions">
                        <a href="#" class="action-remove text-link">Edit</a>
                        <span>|</span>
                        <a href="#" class="action-remove text-link">Remove</a>
                      </div>

                      <div class="progress-tree__detail-track">
                        <div class="progress-tree__detail-trackfill" style="width:80%">
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="progress-tree__item is-inactive">
                  <div class="progress-tree__branch">
                    <span><span></span></span>
                  </div>
                  <div class="progress-tree__content">
                    <div class="progress-tree__title">
                      <p>Buildings</p>
                      <a href="#" class="action-remove"><svg class="icon" title="remove">
                        <use xlink:href="#close-circle-small"></use>
                      </svg></a>
                    </div>
                    <!-- no detail yet
                    <div class="progress-tree__detail">
                    </div>
                    -->
                  </div>
                </div>

                <div class="progress-tree__item is-inactive">
                  <div class="progress-tree__branch">
                    <span></span>
                  </div>
                  <div class="progress-tree__content">
                    <div class="progress-tree__title">
                      <p>Contents</p>
                      <a href="#" class="action-remove"><svg class="icon" title="remove">
                        <use xlink:href="#close-circle-small"></use>
                      </svg></a>
                    </div>
                    <!-- no detail yet
                    <div class="progress-tree__detail">
                    </div>
                    -->
                  </div>
                </div>


              </div>
              <div class="quote-progress__fees">
                <div class="quote-progress__fees-name">
                  Incl. Taxes &amp; Fees <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam." data-original-title="" title=""><svg class="icon icon--sm">
                  <use xlink:href="#help-Icon"></use>
                </svg></a>
              </div>
              <div class="quote-progress__fees-cost">
                <p><strong>R 9 999.00</strong> /mo</p>
              </div>
            </div>

          </div>
        </div>
        <!-- ./quote-progress -->

      </div>

    </div>



    <div class="modal-cart__subtotal">
      <div class="container">
        <div class="modal-cart__subtotal-title">
          Subtotal
        </div>
        <div class="modal-cart__subtotal-cost">
          <p><strong><em>R 999 999</em>.00</strong> /mo</p>
        </div>
      </div>
    </div>





  </div>
</div>
</div>
